/**
 * @name TOKEN_ID
 * @constant
 * @string
 * @description Used to denote an ID in the path name
 */
export const TOKEN_ID = ":id";

/**
 * @name PATH_ABOUT
 * @constant
 * @string
 * @description Path to the about page
 */
export const PATH_ABOUT = '/about';

/**
 * @name PATH_ROOT
 * @constant
 * @string
 * @description Path to the board page
 */
export const PATH_BOARD = '/board';

/**
 * @name PATH_COLLECTION
 * @constant
 * @string
 * @description Path to the collection page
 */
export const PATH_COLLECTION = '/collection';

/**
 * @name PATH_HISTORY
 * @constant
 * @string
 * @description Path to the history page
 */
export const PATH_HISTORY = '/token-history/' + TOKEN_ID;

/**
 * @name PATH_MARKET
 * @constant
 * @string
 * @description Path to the marketplace page
 */
export const PATH_MARKETPLACE = '/marketplace';

/**
 * @name PATH_OFFERS
 * @constant
 * @string
 * @description Path to the offers page
 */
export const PATH_OFFERS = '/offers';

/**
 * @name PATH_ROOT
 * @constant
 * @string
 * @description Path to the default page
 */
export const PATH_ROOT = '/';

/**
 * @name PATH_VIEW
 * @constant
 * @string
 * @description Path to the view page
 */
 export const PATH_VIEW = '/view/' + TOKEN_ID;